export default __webpack_public_path__ + "static/media/23t.28394901.jpg";